export default __webpack_public_path__ + "static/media/f.d88f1149.svg";